import { Box } from "@mui/material";
import useColors from "../../api/hooks/useColors";

export default function LetterAvatar({ name, sx = {} }) {
  const colors = useColors();
  const initial = name.trim().charAt(0).toUpperCase() || "?";
  return (
    <Box
      sx={{
        minWidth: "16px",
        minHeight: "16px",
        borderRadius: "50%",
        backgroundColor: colors.primary_main,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "10px",
        color: colors.common_white,
        ...sx,
      }}
    >
      {initial}
    </Box>
  );
}
